import type { ReactNode } from 'react'

interface ControlRowProps {
  /** Leading title / meta (optional — prefer compact) */
  leading?: ReactNode
  /** Middle: search, filters, segmented controls */
  children?: ReactNode
  /** Trailing actions */
  actions?: ReactNode
  sticky?: boolean
  className?: string
}

/** Single dense chrome row: leading · controls · actions (≤48px). */
export function ControlRow({
  leading,
  children,
  actions,
  sticky = true,
  className = '',
}: ControlRowProps) {
  return (
    <div
      className={`control-row${sticky ? ' control-row--sticky' : ''}${className ? ` ${className}` : ''}`}
      role="toolbar"
    >
      {leading ? <div className="control-row__leading">{leading}</div> : null}
      {children ? <div className="control-row__controls">{children}</div> : null}
      <div className="control-row__spacer" />
      {actions ? <div className="control-row__actions">{actions}</div> : null}
    </div>
  )
}
